const { getUrlSearchParams } = require('./get-url-search-params')
const { isArray } = require('../is-array')
const { size } = require('../size')

/**
 * @param {array|string} remove
 * @returns {string|undefined}
 */
function removeUrlSearchParams (remove) {
  if (
    typeof window === 'undefined' ||
    !remove ||
    !window.location.search
  ) return

  const params = getUrlSearchParams()
  const removeList = isArray(remove) ? remove : [remove]
  const filtered = Object.keys(params).filter(key => !removeList.includes(key))

  // don't continue if original params and filtered params are the same
  if (size(params) === size(filtered)) return

  const outParams = filtered
    .map(key => [key, params[key] || true].join('='))
    .join('&')

  let url = window.location.pathname
  if (outParams) url = `${url}?${outParams}`

  window.history.replaceState(null, null, url)

  return url
}

module.exports = { removeUrlSearchParams }
